<template>
  <div>
    <h1>Manage Standard Leave Comments</h1>
  
    <b-button variant="primary" style="margin-bottom:20px;" v-b-modal.modal-crud>New Standard Leave Comment</b-button>

    <b-modal id="modal-crud" hide-header hide-footer>
      <h2>{{formTitle}}</h2>
      <hr/>
      <form ref="form" @submit.prevent="save">

          <b-form-group 
            label="Standard Leave Comment" label-for="name-input"
            invalid-feedback="Standard Leave Comment is required">
            <b-form-input id="name-input" 
              v-model="$v.editedItem.comment.$model"
              :state="$v.editedItem.comment.$dirty ? !$v.editedItem.comment.$error : null"
              aria-describedby="input-1-live-feedback"
              required>
            </b-form-input> 
            <b-form-invalid-feedback id="input-1-live-feedback">
              This is a required field and must have a length of 4000 characters or less.
            </b-form-invalid-feedback>     
            <b-form-text id="name-input-help">Required.</b-form-text> 
          </b-form-group>

          <b-row style="margin-bottom:20px;">
            <b-col>
              <b-form-checkbox v-model="$v.editedItem.active.$model" name="active-switch" data-test="active-switch" switch>
                  <b>Active?</b>
              </b-form-checkbox>
            </b-col>
          </b-row>

          <b-button @click="close" style="margin-right:15px;">Cancel</b-button>
          <b-button type="submit" variant="primary" :disabled="$v.editedItem.$invalid">Save</b-button>
        </form>
    </b-modal>

    <b-row>
      <b-col style="text-align: right; margin-right: 20px;">
        <b-form-checkbox v-model="showInactive" name="showinactive-filter" data-test="showinactive-filter" switch>
            <b>Include inactive types?</b>
        </b-form-checkbox>
      </b-col>
    </b-row>

    <b-table hover small responsive show-empty
      :fields="fields"
      :items="comments"
      :busy="isLoading">
      <template v-slot:cell(actions)="row">
        <b-button variant="primary" size="sm" @click="editItem(row.item)" class="mr-1">
          edit
        </b-button>
      </template>
      <template #table-caption></template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>

      <template v-slot:empty="scope">
        <p>No standard leave comments found.</p>
      </template>

      <template v-slot:cell(active)="data">
        {{ data.item.active ? 'Yes' : 'No' }}
      </template>

      <div slot="table-busy" class="text-center text-danger my-2">
          <b-spinner class="align-middle" style="margin-right:5px; margin-top:12px;"></b-spinner>
          <strong>Loading, Please Wait...</strong>
      </div>        

    </b-table>
  </div>
</template>

<script>
  import axios from 'axios';
  import axiosRetry from 'axios-retry';
  import { validationMixin } from 'vuelidate'
  import pageTitle from '@/mixins/pageTitle'
  import { required, maxLength } from 'vuelidate/lib/validators'

  axiosRetry(axios, { retries: 3,
    retryDelay: axiosRetry.exponentialDelay  });

  export default {
    title: 'Manage Standard Leave Comments',
    mixins: [validationMixin, pageTitle],
    data: () => ({
      fields: [
        {key: 'comment', sortable: true, label: 'Standard Leave Comment'},
        {key: 'active', sortable: true, label: 'Active?'},
        {key: 'actions', label: 'Actions'}
      ],
      isLoading: false,
      comments: [],
      showInactive: false,
      editedIndex: -1,
      editedItem: {
        comment: null,
        active: true,
      },
      defaultItem: {
        comment: '',
        active: true,
      },
    }),

    validations() {
        return {
          editedItem: {
            comment: {
              required,
              maxLength: maxLength(4000),
            },
            active: { },
          }
        }
    },

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Standard Leave Comment' : 'Edit Standard Leave Comment'
      }
    },

    watch: {
      types() {
        this.isLoading = false
      },
      showInactive() {
        this.fetchStandardComments()
      }
    },

    created () {
      this.initialize()
    },

    methods: {
      fetchStandardComments() {
          this.isLoading = true;
          let fullUrl = `${process.env.VUE_APP_API_BASE_URL}/standardcomment`
          if (this.showInactive) {
            fullUrl = fullUrl + '/all'
          } 
          axios.get(fullUrl)
            .then(response => {
                this.comments = response.data;
                this.isLoading = false;
            })
      },

      initialize () {
        this.fetchStandardComments()
      },

      editItem (item) {
        this.editedIndex = this.comments.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.$bvModal.show('modal-crud')
      },

      deleteItem (item) {
        const index = this.comments.indexOf(item)
        confirm('Are you sure you want to delete this item?') && this.comments.splice(index, 1)
      },

      close () {
        this.$bvModal.hide('modal-crud')
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
          this.$v.$reset()
          this.fetchStandardComments()
        }, 300)
      },

      save () {
        if (this.editedIndex > -1) {
          axios.put(`${process.env.VUE_APP_API_BASE_URL}/standardcomment`, this.editedItem)
            .then(response => { 
              this.fetchStandardComments()
                this.$bvToast.toast('Request Type Updated', {
                  title: 'Status',
                  toaster: 'b-toaster-top-center',
                  solid: true,
                  variant: 'success',
                  appendToast: true
                }) 
            });
          
        } else {
            axios.post(`${process.env.VUE_APP_API_BASE_URL}/standardcomment`, this.editedItem)
            .then(response => { 
              this.fetchStandardComments()
                this.$bvToast.toast('Request Type Saved', {
                  title: 'Status',
                  toaster: 'b-toaster-top-center',
                  solid: true,
                  variant: 'success',
                  appendToast: true
                }) 
            });
          
        }
        this.close()
      },
    }
  }
</script>